var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.02078 12.7319C6.60553 12.1521 5.31794 11.3288 4.20022 10.415L1.51495 13.5306L0 12.2248L2.72367 9.06475C2.10277 8.43153 1.56364 7.79077 1.11821 7.18573L2.72882 6C4.31605 8.15597 7.1302 10.6686 10.3894 11.3893C11.9933 11.744 13.7142 11.6687 15.4943 10.8965C17.2839 10.1202 19.1954 8.6118 21.1182 6L22.7288 7.18573C22.1559 7.9639 21.5758 8.66241 20.9902 9.28594L23.9971 12.2929L22.5829 13.7071L19.5433 10.6675C18.4697 11.5789 17.3822 12.2576 16.2902 12.7313C16.258 12.7453 16.2258 12.7591 16.1936 12.7727L17.2986 16.7805L15.3706 17.3121L14.2852 13.3756C12.7875 13.6933 11.3305 13.6457 9.95761 13.3421L9.93838 13.3379L9.10989 17.4024L7.15019 17.0029L8.02078 12.7319Z",
    fill: "#747474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye-close.98258db7fde4170fb07d0acc22c77931.svg";
export { ForwardRef as ReactComponent };